var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9999 0.368922C17.9999 0.130854 18.2818 0.00514866 18.4589 0.164222L44.772 23.796C44.8937 23.9053 44.8937 24.0961 44.772 24.2054L18.4589 47.8372C18.2818 47.9963 17.9999 47.8706 17.9999 47.6325L17.9999 33.6525C17.9999 33.5726 18.0346 33.4967 18.0949 33.4445L28.7597 24.2085C28.8864 24.0988 28.8864 23.9022 28.7597 23.7925L18.0949 14.5565C18.0346 14.5042 17.9999 14.4283 17.9999 14.3485L17.9999 0.368922Z",
    fill: "#023564"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7113 24.2333C23.8599 24.1132 23.8599 23.8868 23.7113 23.7667L16.9886 18.3327C16.7924 18.1742 16.5 18.3138 16.5 18.5661L16.5 29.4339C16.5 29.6862 16.7924 29.8258 16.9886 29.6673L23.7113 24.2333Z",
    fill: "#023564"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRA);
export default __webpack_public_path__ + "static/media/ArrowR_A.19340b2c2bb0c3d44fe84c93d6bdbcca.svg";
export { ForwardRef as ReactComponent };